import api from "@/api/axios";

const API_URL = "/team-templates";

export const listTeamConstellations = () => api.get(API_URL);
export const getTeamConstellation = (id) => api.get(`${API_URL}/${id}`);
export const createTeamConstellation = (payload) => api.post(API_URL, payload);
export const updateTeamConstellation = (id, payload) => api.put(`${API_URL}/${id}`, payload);
export const deleteTeamConstellation = (id) => api.delete(`${API_URL}/${id}`);
export const applyTeamConstellation = (id, sessionId) => api.post(`${API_URL}/${id}/apply/${sessionId}`);
